export const toSlug = string => `/${ string.split( ' ' )
	.join( '-' )
	.toLowerCase() }`;

export const toTitle = string => string.split( ' ' )
	.map( word => word[ 0 ].toUpperCase() + word.substr( 1 )
		.toLowerCase() )
	.join( ' ' );
